/**
 * Translation index file
 * 
 * This file exports all translations from the separate files.
 */

import { TranslationType } from './types';
import { enCommon, viCommon } from './common';
import { enHome, viHome } from './home';
import { enFooter, viFooter } from './footer';
import { enAdmin, viAdmin } from './admin';
import { enCreateEvent, viCreateEvent } from './createEvent';
import { enMyEvents, viMyEvents } from './myEvents';
import { enEventHistory, viEventHistory } from './eventHistory';
import { enProfile, viProfile } from './profile';
import { enEvent, viEvent } from './event';
import {enShared, viShared} from "@/i18n/translations/shared.ts";

// Combine all English translations
export const enTranslations: TranslationType = {
  ...enCommon,
  ...enHome,
  ...enFooter,
  ...enAdmin,
  ...enCreateEvent,
  ...enMyEvents,
  ...enEventHistory,
  ...enProfile,
  ...enEvent,
  ...enShared
};

// Combine all Vietnamese translations
export const viTranslations: TranslationType = {
  ...viCommon,
  ...viHome,
  ...viFooter,
  ...viAdmin,
  ...viCreateEvent,
  ...viMyEvents,
  ...viEventHistory,
  ...viProfile,
  ...viEvent,
  ...viShared
};

// Export default translations object for compatibility
export default {
  en: enTranslations,
  vi: viTranslations
};